import { Search } from '@carbon/icons-react';
import { Column, Grid } from '@carbon/react';

import { TextInput } from '@/components/TextInput';

interface Props {
  setSearch: (value: string) => void;
}
export function FallFestSearch({ setSearch }: Props) {
  return (
    <Grid className="mb-32">
      <Column sm={4} md={8} lg={12}>
        <TextInput
          placeholder="Search by university, city, state, or country"
          customIcon={<Search />}
          onKeyUp={setSearch}
          debounceKeyUp={500}
        />
      </Column>
    </Grid>
  );
}
